import { BasemapId } from '../app/enums/basemapId';
import { WidgetPosition } from '../app/enums/widgetPosition';

const arcgisVersion = '4.25';

export const baseConfigs = {
  arcgisJsApiSettings: {
    apiUrl: `https://js.arcgis.com/${arcgisVersion}/`,
    cssUrl: `https://js.arcgis.com/${arcgisVersion}/esri/css/main.css`,
  },
  defaultMapSettings: {
    centerLat: 24.45,//22
    centerLon: 39.65,//45
    zoomLevel: 11,//5
    basemapId: BasemapId.satellite,
    widgets: {
      basemapToggle: {
        position: WidgetPosition.topLeft,
        nextBasemap: BasemapId.streets,
      },
      zoom: {
        position: WidgetPosition.topRight,
      },
    },
  },
};
